import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WelcomeScreen } from '../../components/WelcomeScreen';
import { ReportStatusCard } from '../../components/ReportStatusCard';
export function WelcomePage() {
  const navigate = useNavigate();
  // Mock: simula una segnalazione attiva
  // In produzione, questo verrebbe da uno state globale o API
  const [activeReport] = useState({
    status: 'inProgress' as const,
    problemType: 'Rubinetto che perde',
    roomName: 'Bagno',
    estimatedTime: '~2 ore',
    submittedAt: 'Oggi, 14:30'
  });
  const handleSelectCategory = (category: string) => {
    navigate('/guest/report', {
      state: {
        category
      }
    });
  };
  return <div className="max-w-4xl mx-auto px-6 min-h-[calc(100vh-6rem)] flex flex-col" data-id="element-912">
      <div className="flex-1" data-id="element-913">
        <WelcomeScreen onSelectCategory={handleSelectCategory} data-id="element-914" />
      </div>

      {/* Show active report status at bottom - always visible */}
      {activeReport && <div className="pb-6" data-id="element-915">
          <ReportStatusCard status={activeReport.status} problemType={activeReport.problemType} roomName={activeReport.roomName} estimatedTime={activeReport.estimatedTime} submittedAt={activeReport.submittedAt} data-id="element-916" />
        </div>}
    </div>;
}